import { checkToken } from '../../services/login'
import { showError } from '../../store/modules/toasts/actions'

const tokenValidate = async function () {
  try {
    let response = await checkToken()

    if (!response || response === undefined) return false
    if (!response.data || response.data === undefined) return false

    let trueFlag = 'VALID_TOKEN'
    let msg = response.data.message || ''
    if (msg !== trueFlag) return false

    return true
  } catch (error) {
    if (error.hasOwnProperty('message')) {
      if (error.message == 'WITHOUT_TOKEN') {
        showError('Rota restrita, faça login.', 'warning')
        return false
      }
      showError(error.message, 'warning')
      return false
    }

    showError(error)
    return false
  }
}

export default tokenValidate
